<template>
    <MainContent title="Editar subscriptor">
        <template v-slot:header>
            <h3 class="card-title mb-3">Editar subscriptor</h3>
        </template>
        <template v-slot:content>
            <ContentOrLoading>
                <FormSubscriptor v-if="subscriptor" :subscriptor.sync="subscriptor" :loading="loading" @terminado="editarSubscriptor" />
            </ContentOrLoading>
        </template>
    </MainContent>
</template>

<script>
    import apiService from '@/services/api-comunicados';
    import MainContent from '@/components/backend/components/MainContent';
    import FormSubscriptor from '@/components/backend/campana-emails/subscriptores/FormSubscriptor';

    export default {
        data() {
            return {
                subscriptor: null,
                loading: false
            }
        },
        methods: {
            async getSubscriptor() {
                this.loading = true;

                try {
                    const response = await apiService.getSubscriptor(this.subscriptor_id);
                    this.subscriptor = response.data;
                } catch (error) {
                    console.error('Error al cargar el subscriptor:', error);
                } finally {
                    this.loading = false;
                }
            },
            async editarSubscriptor() {
                this.loading = true;

                try {
                    await apiService.updateSubscriptor(this.subscriptor_id, this.subscriptor);
                    this.$toast.success('Subscriptor editado correctamente');
                    this.$router.push('/admin/emails/subscriptores');
                } catch (error) {
                    console.error('Error al actualizar el subscriptor:', error);
                } finally {
                    this.loading = false;
                }
            }
        },
        computed: {
            subscriptor_id() {
                return this.$route.params.subscriptor_id;
            }
        },
        created() {
            this.getSubscriptor();
        },
        components: {
            MainContent, FormSubscriptor
        }
    }
</script>